import { SensitiveSettingsBase } from '../../base/sensitive-settings/sensitive-settings-base.class';
import { IWebCoreSensitiveSettings } from './web-core-sensitive-settings.interface';

export class WebCoreSensitiveSettings extends SensitiveSettingsBase implements IWebCoreSensitiveSettings {
    constructor() {
        super();
    }

    public webSensitive: boolean;

    public init() {}

    public setDefaultValues(): void {
        this.webSensitive = true;
    }

    public translateDefaultValues(): void {}
}
